module.exports = __webpack_public_path__ + "4c89a759a80e00857c96de33649f3d91.png";